mtl.alloy.factory['display-in-modal'] = (function($, app, util) {
    'use strict';

    $("[data-init='display-in-modal']").on('click', function(event){
    	event.preventDefault();

    	var $href = $(this).attr('href');
        var $type = 'ajax';

        if($(this).hasClass('fancybox.iframe'))
            $type = 'iframe';
    	
    	$.fancybox({ 
    		type: $type, 
    		href: $href
    	});
    });

    $("[data-init='display-image-in-modal']").fancybox();

}(jQuery, app, util));
